(function () {
	'use strict';

	angular
	.module('core')
	.controller('projectCtrl', projectCtrl);

	projectCtrl.$inject = ['$http', '$scope', '$rootScope', '$q', '$timeout', '$route', 'Upload'];

	function projectCtrl($http, $scope, $root, $q, $timeout, $route, $upload) {
		var vm = $scope;

		$root.project = $route.current.params.project;
		$root.loading = true;
		$root.keys = [];
		$root.values = [];
		$root.matches = [];

		vm.isObject = function(item){
			return (typeof item == 'object');
		}

		vm.matchSplit = function(key){
			return key.split('|');
		}

		vm.addTag = function(cat){
			$timeout(function(){
				cat.tags.push(angular.copy(cat.tagInput));
				delete cat.tagInput;
			})
		}

		vm.keyTag = function(event, cat){
			$timeout(function(){
				switch(event.key){
	                case 'Enter':
	                vm.addTag(cat);
	                break;
	            }
	        });
		}

		vm.addCategory = function(cat){
			vm.projectData.tags[angular.copy(cat)] = {
				'tags':[]
			}
			delete vm.categoryInput;
		}

		vm.keyCategory = function(event, cat){
			$timeout(function(){
				switch(event.key){
	                case 'Enter':
	                vm.addCategory(cat);
	                break;
	            }
	        });
		}

		vm.isCurrentItem = function(item){
			return angular.equals(item, $root.currentItem);
		}
		vm.isCurrentMatch = function(match){
			return angular.equals(match, $root.currentMatch);
		}

		vm.toggleCurrent = function(index, match){
			if(vm.isCurrentMatch(match) && vm.isCurrentItem(index)){
				delete $root.currentMatch;
				delete $root.currentItem;
			}
			else {
				$root.currentMatch = match;
				$root.currentItem = index;
			}
		}

		vm.addKey = function(key){
			if($root.keys.indexOf(key) < 0){
				$root.keys.push(key);
			}
		}
		vm.addValue = function(value){
			if($root.values.indexOf(value) < 0){
				$root.values.push(value);
			}
		}
		vm.addMatch = function(value){
			if($root.matches.indexOf(value) < 0){
				$root.matches.push(value);
			}
		}

		vm.getKeys = function($event, value){
			var _values = [];
			var _checkEmpty = false;
			if(arguments.length > 2){
				_checkEmpty = arguments[2];
			}
			if(value != '' || _checkEmpty){
				angular.forEach($root.keys, function(val){
					if(val.toLowerCase().indexOf(value.toLowerCase()) >= 0){
						_values.push(val);
					}
				})
			}
			return _values;
		}
		vm.getValues = function($event, value){
			var _values = [];
			var _checkEmpty = false;
			if(arguments.length > 2){
				_checkEmpty = arguments[2];
			}
			if(value != '' || _checkEmpty){
				angular.forEach($root.values, function(val){
					if(val.toLowerCase().indexOf(value.toLowerCase()) >= 0){
						_values.push(val);
					}
				})
			}
			return _values;
		}
		vm.getMatches = function($event, value){
			var _values = [];
			var _checkEmpty = false;
			if(arguments.length > 2){
				_checkEmpty = arguments[2];
			}
			if(value != '' || _checkEmpty){
				angular.forEach($root.matches, function(val){
					if(val.toLowerCase().indexOf(value.toLowerCase()) >= 0){
						_values.push(val);
					}
				})
			}
			return _values;
		}

		vm.init = function() {
			$http.get('./services/project.php?project='+$root.project+'&t='+(new Date()).getTime()).
			then(function(response){
				$root.loading = false;

				vm.projectData = response.data;

				if(vm.projectData.tags == undefined){
					vm.projectData.tags = {
						'Other':{
							'tags':[]
						}
					}
				}
			});
		}
		vm.init();
	}
})();